<script>
  import DayStatus from "./DayStatus.svelte";
  import DaySessions from "./DaySessions.svelte";
  import { _ } from "svelte-i18n";

  export let startDate, endDate, weekNo;
  export let weekSessions = [];
  export let daysInWeek = [];
  export let athlete;

  let gender = "female";

  function formatHours(minutes) {
    const hours = Math.floor(minutes / 60).toFixed(0);
    const min = ("0" + (minutes % 60).toFixed(0)).slice(-2);

    return hours + ":" + min;
  }

  function dateOfWeekday(startOfWeek, dayOfWeek) {
    const d = new Date(startOfWeek.toISOString().slice(0, 10));
    return new Date(d.setDate(d.getDate() + dayOfWeek));
  }
</script>

<div class="week-calendar-wrapper">
  <div class="summary-week">
    <div class="summary-week__meta">
      <div class="summary-week__week-number">
        <span class="summary-week__label">{$_("plans.nav.week")}</span>
        <span class="summary-week__number">{weekNo}</span>
      </div>
      <div class="summary-week__meta-inner-wrap">
        <div class="summary-week__heading">
          <span class="summary-week__dates">
            {startDate.toLocaleString("no", { day: "numeric", month: "long" })} –&nbsp;
            {endDate.toLocaleString("no", {
              day: "numeric",
              month: "long",
            })}</span
          >
          <span class="summary-week__year">
            {endDate.toLocaleString("no", { year: "numeric" })}</span
          >
        </div>
        <div class="summary-week__load">
          <span>{$_("plans.weekload")}:</span>{$_("plans.notDefined")}
        </div>
        <div class="summary-week__training-period">
          <span>{$_("plans.trainingPeriod")}:</span>{$_("plans.notDefined")}
        </div>
      </div>
      <div class="summary-week__table-overview">
        <div class="table-mini">
          <table>
            <colgroup>
              <col class="table-mini__col-1" />
              <col class="table-mini__col-2" />
              <col class="table-mini__col-3" />
            </colgroup>
            <thead>
              <tr>
                <td />
                <th>{$_("plans.performed")}</th>
                <th>{$_("plans.planned")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>{$_("plans.trainingHours")}:</th>
                <td
                  >{formatHours(
                    weekSessions.reduce(
                      (sum, item) =>
                        sum +
                        []
                          .concat(item.warmUp)
                          .concat(item.main)
                          .concat(item.conclusion)
                          .reduce(
                            (sum, entry) =>
                              sum +
                              (entry !== undefined &&
                              entry.duration !== undefined
                                ? parseInt(entry.duration)
                                : 0),
                            0
                          ),
                      0
                    )
                  )}</td
                >
                <td />
              </tr>
              <tr>
                <th>{$_("statistics.sessions")}:</th>
                <td>{weekSessions.length}</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="summary-week__unit-toggles" style="display:none">
      <div class="nav-tabs nav-tabs--small nav-tabs--right">
        <button class="button button--tab is-active" aria-current="true"
          >Tid</button
        >
        <button class="button button--tab" aria-current="false">Prosent</button>
        <button class="button button--tab" aria-current="false">Økt</button>
      </div>
      <div class="summary-week__movement-types is-scrolled-to-end">
        <div class="overflow-inner-wrap">
          <div class="table-movement-types">
            <table class="">
              <thead>
                <tr>
                  <th> <span>Håndball</span></th>
                  <th>
                    <span>Løping</span>
                  </th>
                  <th>
                    <span>Sykling</span>
                  </th>
                  <th>
                    <span>Ballspill</span>
                  </th>
                  <th>
                    <span>Svømming</span>
                  </th>
                  <th>
                    <span>Annet</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span />
                  </td>
                  <td>
                    <span />
                  </td>
                  <td>
                    <span />
                  </td>
                  <td>
                    <span />
                  </td>
                  <td>
                    <span />
                  </td>
                  <td>
                    <span />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="summary-week__izones">
        <div class="izone-table">
          <h4 class="izone-table-title">Intensitetssoner</h4>
          <table class="izone-table">
            <thead>
              <tr>
                <th
                  class="izone-table__heading izone-table__heading--i1-three-izones"
                />
                <th
                  class="izone-table__heading izone-table__heading--i2-three-izones"
                />
                <th
                  class="izone-table__heading izone-table__heading--i3-three-izones"
                />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="izone-table__value" />
                <td class="izone-table__value" />
                <td class="izone-table__value" />
              </tr>
            </tbody>
          </table>
        </div>
        <div class="izone-barchart">
          <ul class="izone-barchart__bars">
            <li
              class="izone-barchart__izone izone-barchart__izone--1-three-izones"
              style="height: 0%;"
            >
              <span class="izone-barchart__done">
                <span class="izone-barchart__figure">
                  0:00
                  <span class="izone-barchart__percentage" />
                </span>
              </span>
            </li>
            <li
              class="izone-barchart__izone izone-barchart__izone--2-three-izones"
              style="height: 0%;"
            >
              <span class="izone-barchart__done">
                <span class="izone-barchart__figure">
                  0:00
                  <span class="izone-barchart__percentage" />
                </span>
              </span>
            </li>
            <li
              class="izone-barchart__izone izone-barchart__izone--3-three-izones"
              style="height: 0%;"
            >
              <span class="izone-barchart__done">
                <span class="izone-barchart__figure">
                  0:00
                  <span class="izone-barchart__percentage" />
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="summary-week__specific-training" style="display:none">
      <div class="progress">
        <div class="progress__label">
          <span>
            <strong>0% spesifikk trening.</strong>
          </span>
          <span>100% generell trening.</span>
        </div>
        <div class="progress__bar progress__bar--specific-general">
          <div class="progress__bar-done" style="width: 0%;" />
          <div class="progress__bar-track" />
        </div>
      </div>
    </div>
  </div>
  <ol class="week-calendar">
    {#each [$_("days.short.monday"), $_("days.short.tuesday"), $_("days.short.wednesday"), $_("days.short.thursday"), $_("days.short.friday"), $_("days.short.saturday"), $_("days.short.sunday")] as weekday, index}
      <li class="week-calendar__day">
        <div class="week-calendar__day-contents">
          <a
            class="week-calendar__day-info {dateOfWeekday(startDate, index)
              .toISOString()
              .slice(0, 10) === new Date().toISOString().slice(0, 10)
              ? 'week-calendar__day-info--is-today'
              : ''}"
            on:click|preventDefault
            href="/planer/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-07-11"
          >
            <h3 class="week-calendar__day-name">{weekday}</h3>
            <time class="week-calendar__day-date"
              >{dateOfWeekday(startDate, index).getDate()}</time
            >
            <DayStatus
              date={dateOfWeekday(startDate, index)}
              loggedStatus={daysInWeek.filter(
                (item) =>
                  item.date ===
                  dateOfWeekday(startDate, index).toISOString().slice(0, 10)
              )}
            />
          </a>
          <nav class="week-calendar__activities">
            <DaySessions
              date={dateOfWeekday(startDate, index)}
              daySessions={weekSessions.filter(
                (item) =>
                  item.date ===
                  dateOfWeekday(startDate, index).toISOString().slice(0, 10)
              )}
            />
            <button class="week-calendar__button-add-activity">Logg økt</button>
          </nav>
        </div>
      </li>
    {/each}
  </ol>
  <div class="week-bottom-matter">
    <div class="weekly-parameters-table">
      <div class="table-mini table-mini--weekly-parameters-table">
        <h3>{$_("plans.average.title")}</h3>
        <table
          aria-label="Tabell med gjennomsnitt per uke for et utvalg dagsparametre"
        >
          <colgroup>
            <col class="table-mini__col-1" />
            <col class="table-mini__col-2" />
            <col class="table-mini__col-3" />
          </colgroup>
          <tbody>
            <tr class="">
              <th class="">{$_("plans.form")}:</th>
              <td class="" />
              <td class="" style="font-weight: normal; white-space: nowrap;" />
            </tr>
            <tr class="extraBottomMargin">
              <th class="extraBottomMargin"
                >{$_("sessions.form.experiencedLoad.title")}:</th
              >
              <td class="extraBottomMargin" />
              <td
                class="extraBottomMargin"
                style="font-weight: normal; white-space: nowrap;"
              />
            </tr>
            <tr class="extraTopMargin">
              <th class="extraTopMargin">{$_("plans.average.pulse")}:</th>
              <td class="extraTopMargin" />
              <td
                class="extraTopMargin"
                style="font-weight: normal; white-space: nowrap;"
              />
            </tr>
            <tr class="">
              <th class="">{$_("plans.average.sleep")}:</th>
              <td class="" />
              <td class="" style="font-weight: normal; white-space: nowrap;" />
            </tr>
            <tr class="">
              <th class="">{$_("plans.average.sleepLength")}:</th>
              <td class="" />
              <td class="" style="font-weight: normal; white-space: nowrap;" />
            </tr>
            <tr class="">
              <th class="">{$_("plans.average.mental")}:</th>
              <td class="" />
              <td class="" style="font-weight: normal; white-space: nowrap;" />
            </tr>
            <tr class="">
              <th class="">{$_("plans.average.physical")}:</th>
              <td class="" />
              <td class="" style="font-weight: normal; white-space: nowrap;" />
            </tr>
            {#if gender === "female"}
              <tr class="">
                <th class="">{$_("plans.average.menstruation")}:</th>
                <td class="" />
                <td
                  class=""
                  style="font-weight: normal; white-space: nowrap;"
                />
              </tr>
            {/if}
          </tbody>
        </table>
      </div>
    </div>
    {#if athlete?.access?.canComment !== false}
      <div class="weekly-comments">
        <form>
          <fieldset class="form-section form-section--paddingless">
            <h3>{$_("plans.comment")}</h3>
            <ul class="list-comments" />
            <label class="input" for="comment-week">
              <span class="input__label">{$_("sessions.form.newComment")}</span>
              <textarea
                rows="6"
                type="text"
                inputmode="text"
                name="comment-week"
                id="comment-week"
                class="input__text"
              />
            </label>
            <label
              style="display: none;"
              class="checkbox"
              for="comment-notification-week"
            >
              <input
                type="checkbox"
                class="checkbox__input-hidden"
                id="comment-notification-week"
                name="comment-notification-week"
                value="on"
              />
              <span class="checkbox__input-custom" />
              <span class="checkbox__label">Varsle trener</span>
            </label>
            <button type="button" class="button button--icon button--icon-add"
              >{$_("generic.buttons.add")}</button
            >
          </fieldset>
        </form>
      </div>
    {/if}
  </div>
</div>
